import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import { Eye, EyeOff } from "lucide-react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const isFormValid = () => {
    return email && password;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        throw new Error("Login gagal");
      }

      const data = await res.json();

      if (data?.token) {
        // simpan token di cookie (1 hari, secure untuk https)
        Cookies.set("token", data.token, { expires: 1, secure: true });

        // redirect ke page utama
        navigate("/pageutama");
      }
    } catch (error: any) {
      console.error(error);
      alert("Login gagal, periksa email/password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* background putih gradiasi emas */}
      <div className="bg-gradient-to-b from-white to-[#cfa84d] mx-auto flex justify-center min-h-screen">
        <div className="px-7 py-5 rounded-lg w-full md:mx-8 lg:mx-20 max-w-md  h-full my-auto">
          {/* <Link to="/">
            <div className="flex justify-start">
              <div className="bg-[#cfa84d] text-white px-3 py-3 rounded-full shadow">
                <img src="/logo/back.png" alt="" className="w-5 h-5" />
              </div>
            </div>
          </Link> */}

          <div className="flex justify-center my-3">
            <img src="/images/pancasila.png" alt="" className="w-20 h-24" />
          </div>

          <h1 className="text-3xl md:text-4xl mt-4 mb-8 text-center font-bold text-[#cfa84d]">
            Login <span className="text-gray-700">User</span>
          </h1>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan Email" />
            </div>

            <div className="flex flex-col gap-2 relative">
              <label className="text-gray-700 font-semibold">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3 pr-10"
                placeholder="Masukan Password"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-11 text-[#cfa84d]">
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            <div className="flex justify-end mt-2">
              <button
                type="submit"
                disabled={!isFormValid() || loading}
                className={`py-2 px-8 rounded-lg text-white text-center transition-all w-full ${!isFormValid() || loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#cfa84d] hover:bg-white hover:text-[#cfa84d] border border-[#cfa84d]"}`}>
                {loading ? "Loading..." : "Login"}
              </button>
            </div>

            <div className="text-gray-700 text-center" onClick={() => setIsOpen(true)}>
              Belum Punya Akun ? <br />
              <span className="font-bold">
                {/* <Link to={"/register"}>Daftar Sebagai Masyarakat </Link> */}
                Daftar Sebagai Masyarakat{" "}
              </span>
              atau
              <br />
              <span className="font-bold">
                {/* <Link to={"/registerStaff"}>Daftar Sebagai Staf Kementerian</Link> */}
                Daftar Sebagai Staf Kementerian
              </span>
            </div>
          </form>
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg text-lg ">
            Fitur Sedang Dalam Pengembangan
            <div className="flex justify-center mt-4">
              <button onClick={() => setIsOpen(false)} className="bg-[#cfa84d] text-white px-7 py-2 rounded-lg shadow">
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Login;
